// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch_select {
    display: flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
    /* Reset label styling inherited from host headers (e.g. .code_section__pane_label). */
    text-transform: none;
    font-weight: normal;
    letter-spacing: 0;
}

.branch_select__actions_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    padding: 0;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 1;
    color: var(--color-text-muted);
    border-radius: 3px;
    cursor: pointer;
    transition: color 0.15s, background-color 0.15s;
}

@media (pointer: fine) {
    .branch_select__actions_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.branch_select__actions_btn--busy {
    cursor: default;
}

@media (pointer: fine) {
    .branch_select__actions_btn--busy:hover {
        background-color: transparent;
    }
}

.branch_select__actions_spinner {
    width: 10px;
    height: 10px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: branch_select__spin 0.7s linear infinite;
}

@keyframes branch_select__spin {
    to { transform: rotate(360deg); }
}

.branch_select__trigger_wrap {
    position: relative;
    flex: 1;
    min-width: 0;
}

.branch_select__icon {
    font-size: 14px;
    color: var(--color-accent);
    flex-shrink: 0;
}

.branch_select__trigger {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    height: 26px;
    padding: 0 8px;
    background: var(--color-input-bg);
    border: 1px solid var(--color-input-border);
    border-radius: 3px;
    cursor: pointer;
    font-size: 13px;
    color: var(--color-text);
    transition: border-color 0.15s;
}

@media (pointer: fine) {
    .branch_select__trigger:hover {
        border-color: var(--color-input-border-focus);
    }
}

.branch_select__trigger_label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.branch_select__divergence {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 11px;
    font-variant-numeric: tabular-nums;
    color: var(--color-accent);
}

.branch_select__trigger_arrow {
    color: var(--color-text-muted);
    font-size: 11px;
    flex-shrink: 0;
}

.branch_select__backdrop {
    position: fixed;
    inset: 0;
    z-index: 1010;
}

.branch_select__dropdown {
    position: fixed;
    /* top + left set by inline style from measured trigger rect */
    width: min(800px, 90vw);
    max-height: 800px;
    display: flex;
    flex-direction: column;
    background: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 1011;
    overflow: hidden;
}

@media (pointer: coarse) {
    .branch_select__dropdown {
        left: 0 !important;
        right: 0;
        width: 100%;
        max-width: none;
        max-height: 75vh;
    }
}

.branch_select__search_wrap {
    flex-shrink: 0;
    background: var(--color-bg-3);
    border-bottom: 1px solid var(--color-border);
    transition: border-bottom-color 0.15s;
}

.branch_select__search_wrap:focus-within {
    border-bottom-color: var(--color-accent);
}

/* Reset text_input defaults to fit the compact search row */
.branch_select__search_wrap .text_input,
.branch_select__search_wrap .text_input__touch_wrapper {
    height: 28px;
}

.branch_select__search_wrap .text_input {
    padding: 0 8px;
    font-size: 12px;
    background: transparent;
    border: none;
    border-radius: 0;
    transition: none;
}

.branch_select__search_wrap .text_input:focus {
    border-color: transparent;
}

.branch_select__list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.branch_select__no_results {
    padding: 6px 10px;
    font-size: 12px;
    color: var(--color-text-muted);
}

.branch_select__option {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    font-size: 13px;
    color: var(--color-text);
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .branch_select__option:hover {
        background-color: var(--color-bg-3);
    }
}

.branch_select__option.active {
    color: var(--color-accent);
}

.branch_select__option--vault {
    color: var(--color-text-muted);
    font-style: italic;
}

.branch_select__option--vault.active {
    color: var(--color-accent);
    font-style: normal;
}

.branch_select__option--create {
    color: var(--color-text-muted);
}

@media (pointer: fine) {
    .branch_select__option--create:hover {
        color: var(--color-text);
    }
}

.branch_select__divider {
    height: 1px;
    background: var(--color-border);
    margin: 2px 0;
}

.branch_select__input {
    flex: 1;
    min-width: 0;
    height: 26px;
    padding: 0 7px;
    font-size: 13px;
    background: var(--color-bg-3);
    color: var(--color-text);
    border: 1px solid var(--color-border);
    border-radius: 3px;
    outline: none;
}

.branch_select__input:focus {
    border-color: var(--color-accent);
}

.branch_select__create_btn {
    height: 26px;
    padding: 0 9px;
    font-size: 13px;
    background-color: var(--color-accent);
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    flex-shrink: 0;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .branch_select__create_btn:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.branch_select__create_btn:disabled {
    opacity: 0.5;
    cursor: default;
}

.branch_select__confirm_actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.branch_select__confirm_btn {
    width: 100%;
    height: 28px;
    padding: 0 10px;
    font-size: 13px;
    border-radius: 3px;
    cursor: pointer;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background-color 0.15s;
}

.branch_select__confirm_btn--primary {
    background-color: var(--color-accent);
    color: #fff;
}

@media (pointer: fine) {
    .branch_select__confirm_btn--primary:hover {
        background-color: var(--color-accent-hover);
    }
}

.branch_select__confirm_btn--secondary {
    background-color: var(--color-bg-3);
    color: var(--color-text-muted);
    border: 1px solid var(--color-border);
}

@media (pointer: fine) {
    .branch_select__confirm_btn--secondary:hover {
        color: var(--color-text);
        background-color: var(--color-input-bg);
    }
}

/* Wrapper used when the branch select appears as a standalone row in pane content */
.branch_select_row {
    padding: 6px 13px;
    border-bottom: 1px solid var(--color-border);
}
`, "",{"version":3,"sources":["webpack://./components/BranchSelect/s.branch_select.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,sFAAsF;IACtF,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iCAAiC;IACjC,2CAA2C;IAC3C,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI;QACI,6CAA6C;IACjD;AACJ;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,8DAA8D;IAC9D,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,4CAA4C;IAC5C,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,4DAA4D;AAC5D;;IAEI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI;QACI,wBAAwB;QACxB,uCAAuC;IAC3C;AACJ;;AAEA,oFAAoF;AACpF;IACI,iBAAiB;IACjB,4CAA4C;AAChD","sourcesContent":[".branch_select {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    min-width: 0;\n    /* Reset label styling inherited from host headers (e.g. .code_section__pane_label). */\n    text-transform: none;\n    font-weight: normal;\n    letter-spacing: 0;\n}\n\n.branch_select__actions_btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: 0;\n    line-height: 1;\n    color: var(--color-text-muted);\n    border-radius: 3px;\n    cursor: pointer;\n    transition: color 0.15s, background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .branch_select__actions_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.branch_select__actions_btn--busy {\n    cursor: default;\n}\n\n@media (pointer: fine) {\n    .branch_select__actions_btn--busy:hover {\n        background-color: transparent;\n    }\n}\n\n.branch_select__actions_spinner {\n    width: 10px;\n    height: 10px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: branch_select__spin 0.7s linear infinite;\n}\n\n@keyframes branch_select__spin {\n    to { transform: rotate(360deg); }\n}\n\n.branch_select__trigger_wrap {\n    position: relative;\n    flex: 1;\n    min-width: 0;\n}\n\n.branch_select__icon {\n    font-size: 14px;\n    color: var(--color-accent);\n    flex-shrink: 0;\n}\n\n.branch_select__trigger {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n    height: 26px;\n    padding: 0 8px;\n    background: var(--color-input-bg);\n    border: 1px solid var(--color-input-border);\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--color-text);\n    transition: border-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .branch_select__trigger:hover {\n        border-color: var(--color-input-border-focus);\n    }\n}\n\n.branch_select__trigger_label {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.branch_select__divergence {\n    display: inline-flex;\n    align-items: center;\n    flex-shrink: 0;\n    font-size: 11px;\n    font-variant-numeric: tabular-nums;\n    color: var(--color-accent);\n}\n\n.branch_select__trigger_arrow {\n    color: var(--color-text-muted);\n    font-size: 11px;\n    flex-shrink: 0;\n}\n\n.branch_select__backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1010;\n}\n\n.branch_select__dropdown {\n    position: fixed;\n    /* top + left set by inline style from measured trigger rect */\n    width: min(800px, 90vw);\n    max-height: 800px;\n    display: flex;\n    flex-direction: column;\n    background: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    z-index: 1011;\n    overflow: hidden;\n}\n\n@media (pointer: coarse) {\n    .branch_select__dropdown {\n        left: 0 !important;\n        right: 0;\n        width: 100%;\n        max-width: none;\n        max-height: 75vh;\n    }\n}\n\n.branch_select__search_wrap {\n    flex-shrink: 0;\n    background: var(--color-bg-3);\n    border-bottom: 1px solid var(--color-border);\n    transition: border-bottom-color 0.15s;\n}\n\n.branch_select__search_wrap:focus-within {\n    border-bottom-color: var(--color-accent);\n}\n\n/* Reset text_input defaults to fit the compact search row */\n.branch_select__search_wrap .text_input,\n.branch_select__search_wrap .text_input__touch_wrapper {\n    height: 28px;\n}\n\n.branch_select__search_wrap .text_input {\n    padding: 0 8px;\n    font-size: 12px;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    transition: none;\n}\n\n.branch_select__search_wrap .text_input:focus {\n    border-color: transparent;\n}\n\n.branch_select__list {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n.branch_select__no_results {\n    padding: 6px 10px;\n    font-size: 12px;\n    color: var(--color-text-muted);\n}\n\n.branch_select__option {\n    display: flex;\n    align-items: center;\n    padding: 6px 10px;\n    font-size: 13px;\n    color: var(--color-text);\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .branch_select__option:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.branch_select__option.active {\n    color: var(--color-accent);\n}\n\n.branch_select__option--vault {\n    color: var(--color-text-muted);\n    font-style: italic;\n}\n\n.branch_select__option--vault.active {\n    color: var(--color-accent);\n    font-style: normal;\n}\n\n.branch_select__option--create {\n    color: var(--color-text-muted);\n}\n\n@media (pointer: fine) {\n    .branch_select__option--create:hover {\n        color: var(--color-text);\n    }\n}\n\n.branch_select__divider {\n    height: 1px;\n    background: var(--color-border);\n    margin: 2px 0;\n}\n\n.branch_select__input {\n    flex: 1;\n    min-width: 0;\n    height: 26px;\n    padding: 0 7px;\n    font-size: 13px;\n    background: var(--color-bg-3);\n    color: var(--color-text);\n    border: 1px solid var(--color-border);\n    border-radius: 3px;\n    outline: none;\n}\n\n.branch_select__input:focus {\n    border-color: var(--color-accent);\n}\n\n.branch_select__create_btn {\n    height: 26px;\n    padding: 0 9px;\n    font-size: 13px;\n    background-color: var(--color-accent);\n    color: #fff;\n    border-radius: 3px;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .branch_select__create_btn:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.branch_select__create_btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.branch_select__confirm_actions {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.branch_select__confirm_btn {\n    width: 100%;\n    height: 28px;\n    padding: 0 10px;\n    font-size: 13px;\n    border-radius: 3px;\n    cursor: pointer;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    transition: background-color 0.15s;\n}\n\n.branch_select__confirm_btn--primary {\n    background-color: var(--color-accent);\n    color: #fff;\n}\n\n@media (pointer: fine) {\n    .branch_select__confirm_btn--primary:hover {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.branch_select__confirm_btn--secondary {\n    background-color: var(--color-bg-3);\n    color: var(--color-text-muted);\n    border: 1px solid var(--color-border);\n}\n\n@media (pointer: fine) {\n    .branch_select__confirm_btn--secondary:hover {\n        color: var(--color-text);\n        background-color: var(--color-input-bg);\n    }\n}\n\n/* Wrapper used when the branch select appears as a standalone row in pane content */\n.branch_select_row {\n    padding: 6px 13px;\n    border-bottom: 1px solid var(--color-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
